import {ForgotPasswordComponent, LogoutComponent, PasswordRestoreComponent} from '@ngx-ivengi/cleanzone';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {Ng2StateDeclaration, UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn} from '@ngx-ivengi/locale';
import {LoginComponent} from './components/login/login.component';

export let CHILD_STATES: Ng2StateDeclaration[] = [
  {
    name: 'login',
    component: LoginComponent,
    url: '/login',
    data: {
      insecure: true
    }
  },
  {
    name: 'forgotpassword',
    component: ForgotPasswordComponent,
    url: '/wachtwoord-vergeten',
    data: {
      insecure: true
    }
  },
  {
    name: 'passwordrestore',
    component: PasswordRestoreComponent,
    url: '/wachtwoord-herstellen?token',
    data: {
      insecure: true
    }
  },
  {
    name: 'logout',
    component: LogoutComponent,
    url: '/logout'
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/app.routes.ts